import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { isFormControlRequired } from '@digilize/shared/utils/helpers/src';

@Component({
  selector: 'lib-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DatepickerComponent {
  @Input() control: UntypedFormControl;
  @Input() label: string;
  /** Translation key of what the field means, shown behind the dashboard's info icon next to the label. */
  @Input() info?: string;
  @Input() disabled: boolean;
  /**
   * Which view the calendar opens on. A date near today — a start date, a filter range —
   * wants the default day grid, but a date of birth is decades away: `multi-year` opens on
   * the year grid and Material then walks year → month → day on its own, instead of
   * leaving the user to find the header button that switches views.
   */
  @Input() startView: 'month' | 'year' | 'multi-year' = 'month';
  isFormControlRequired(): boolean {
    return isFormControlRequired(this.control);
  }
}
